import axios        from "axios";
import {url_path}   from "./paths";

export default {
    state: {
        user: { },
        isAuthorized: false
    },
    mutations: {
        setUser (state, payload) {
            state.user = payload;
        },
        setUnAuth (state) {
            localStorage.removeItem('teo_token');
            localStorage.removeItem('teo_refresh_token');
            localStorage.removeItem('teo_expire_at');
            state.isAuthorized = false;
            state.user = { };
        },
        setAuth (state, payload) {
            localStorage.setItem('teo_token', payload.access_token);
            localStorage.setItem('teo_refresh_token', payload.refresh_token);
            localStorage.setItem('teo_expire_at', payload.expires_in * 1000);
            state.isAuthorized = true;
        },
        setAuthLocal (state) {
            state.isAuthorized = true;
        }
    },
    actions: {
        async getUser ({commit}) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer '+ localStorage.teo_token;
                const now = Date.now() + 86400*3*1000;
                if (now > +localStorage.teo_expire_at){
                    const refresh = await axios.post(url_path.url_refresh_token, null, {
                        headers:{
                            'Refreshtoken': localStorage.teo_refresh_token
                        }
                    });
                    localStorage.setItem('teo_token', refresh.data.access_token);
                    localStorage.setItem('teo_refresh_token', refresh.data.refresh_token);
                    localStorage.setItem('teo_expire_at', new Date( refresh.data.expires_in ).getTime());
                    axios.defaults.headers.common['Authorization'] = 'Bearer '+ refresh.data.access_token;
                }

                const response = await axios.get(url_path.url_users_get_current_user);
                if (response.data.status == url_path.response_status_ok){
                    commit('setUser', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                commit('setUser', { });
                commit('setUnAuth');
                throw error
            }
        },
        async loginUser ({commit}, {email, password}) {
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_users_login, {email: email, password: password, remember_me: 1});

                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                    commit('setAuth', response.data.data);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                    commit('setUnAuth');
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'User not found');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                    commit('setUnAuth');
                }
                throw error
            }
        },
        async logoutUser ({commit}) {
            commit('clearError');
            commit('setLoading', true);
            try {
                await axios.get(url_path.url_users_logout);
                commit('setUser', null);
                commit('setLoading', false);
                commit('setUnAuth');
            }
            catch (error) {
                commit('setLoading', false);
                commit('setError', error.message);
                commit('setUnAuth');
                throw error
            }
        },
        setAuthByLocalStorage ({commit}) {
            commit('setAuthLocal');
        },
        setUnAuthByLocalStorage ({commit}) {
            commit('setUnAuth');
        },
        sendNotificaton ({commit}, text) {
            commit('setError', text);
        },
        setAuthorizedStatus ({commit}) {
            const token = localStorage.getItem('teo_token');
            const token_expire = localStorage.getItem('teo_expire_at');
            if (token && +token_expire > Date.now()){
                commit('setAuthLocal');
            }
            else{
                commit('setUnAuth');
            }
        },
    },
    getters: {
        user (state) {
            return state.user;
        },
        isAuthorized (state) {
            return state.isAuthorized;
        }
    }
}
